import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { BannerImage, BannerVideo } from '../../typings/domain';
import { Shape2, Shape2Icon, Shape2Tone } from '../Shape2/Shape2';

import './GridBannerImage.css';

interface GridBannerImageProps {
    cls?: string;
    image: BannerImage | BannerVideo;
    onClick?: () => void;
}

const BLOCK = 'grid-banner-image';

export class GridBannerImage extends React.PureComponent<GridBannerImageProps> {
    render() {
        const {
            cls,
            onClick,
            image: { name, url }
        } = this.props;

        return (
            <div
                className={classNames(
                    Bem.cls({
                        block: BLOCK,
                        mods: { clickable: Boolean(onClick) }
                    }),
                    cls
                )}
                onClick={onClick}
            >
                <img
                    src={url}
                    alt={name}
                    className={Bem.cls('grid-banner-image', 'image')}
                />
                {onClick && (
                    <div className={Bem.cls(BLOCK, 'overlay')}>
                        <Shape2
                            width={32}
                            height={32}
                            icon={Shape2Icon.eye}
                            tone={Shape2Tone.white}
                        />
                    </div>
                )}
            </div>
        );
    }
}
